import { useMediaQuery, useTheme } from '@mui/material'
import { useActiveSmokingSession } from '@hooks/useActiveSmokingSession'

/** Compact live-session strip above bottom nav on viewports below `md`. */
export function useShowMiniSessionBar(): boolean {
  const theme = useTheme()
  const belowMd = !useMediaQuery(theme.breakpoints.up('md'), { noSsr: true })
  const { activeSession } = useActiveSmokingSession()
  return belowMd && Boolean(activeSession)
}
